import React from "react";

const STYLES = {
    new: { bg: "rgba(124,255,79,0.10)", border: "rgba(124,255,79,0.35)", color: "#7CFF4F" },
    contacted: { bg: "rgba(96,165,250,0.10)", border: "rgba(96,165,250,0.35)", color: "#93C5FD" },
    qualified: { bg: "rgba(124,255,79,0.18)", border: "rgba(124,255,79,0.55)", color: "#A6FF7A" },
    not_qualified: { bg: "rgba(161,161,170,0.10)", border: "rgba(161,161,170,0.30)", color: "#A1A1AA" },
    closed: { bg: "rgba(100,116,139,0.10)", border: "rgba(100,116,139,0.30)", color: "#94A3B8" },
    archived: { bg: "rgba(82,82,91,0.08)", border: "rgba(82,82,91,0.25)", color: "#71717A" },
};

const LABELS = {
    new: "New",
    contacted: "Contacted",
    qualified: "Qualified",
    not_qualified: "Not Qualified",
    closed: "Closed",
    archived: "Archived",
};

export const StatusPill = ({ status, "data-testid": testId }) => {
    const s = STYLES[status] || STYLES.new;
    return (
        <span
            data-testid={testId}
            className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11.5px] font-medium uppercase tracking-wider"
            style={{
                background: s.bg,
                borderColor: s.border,
                color: s.color,
            }}
        >
            <span
                aria-hidden
                className="h-1 w-1 rounded-full"
                style={{ background: s.color }}
            />
            {LABELS[status] || status}
        </span>
    );
};

export const DIVISION_LABEL = {
    funding: "Funding",
    realestate: "Real Estate",
    materials: "Materials",
    consulting: "Consulting",
    contact: "Contact",
};

export const DivisionPill = ({ division }) => (
    <span className="inline-flex items-center rounded-md border border-border-default bg-[var(--bg-elevated-2)] px-2 py-0.5 text-[11px] uppercase tracking-wider text-text-secondary">
        {DIVISION_LABEL[division] || division}
    </span>
);

export default StatusPill;
